export type TreeOption = {
  label: string;
  value: string;
  children?: TreeOption[];
};

export const CONTACT_CHILDREN: TreeOption[] = [
  { label: "Full Name", value: "{{contact.name}}" },
  { label: "First Name", value: "{{contact.first_name}}" },
  { label: "Last Name", value: "{{contact.last_name}}" },
  { label: "Email", value: "{{contact.email}}" },
  { label: "Phone", value: "{{contact.phone}}" },
  { label: "Company Name", value: "{{contact.company_name}}" },
  { label: "Full Address", value: "{{contact.full_address}}" },
  { label: "Address 1", value: "{{contact.address1}}" },
  { label: "City", value: "{{contact.city}}" },
  { label: "State", value: "{{contact.state}}" },
  { label: "Country", value: "{{contact.country}}" },
  { label: "Postal Code", value: "{{contact.postal_code}}" },
  { label: "Date of birth", value: "{{contact.date_of_birth}}" },
  { label: "Source", value: "{{contact.source}}" },
  { label: "Website", value: "{{contact.website}}" },
  { label: "ID", value: "{{contact.id}}" },
];

export const RIGHT_NOW_CHILDREN: TreeOption[] = [
  { label: "Second", value: "{{right_now.second}}" },
  { label: "Minute", value: "{{right_now.minute}}" },
  { label: "Hour 24h format", value: "{{right_now.hour}}" },
  { label: "Hour AM/PM format", value: "{{right_now.hour_ampm}}" },
  { label: "Time 24h format", value: "{{right_now.time}}" },
  { label: "Time AM/PM format", value: "{{right_now.time_ampm}}" },
  { label: "AM/PM", value: "{{right_now.ampm}}" },
  { label: "Day", value: "{{right_now.day}}" },
  {
    label: "Day of the week extended English",
    value: "{{right_now.day_of_week}}",
  },
  { label: "Month", value: "{{right_now.month}}" },
  { label: "Month extended English", value: "{{right_now.month_english}}" },
  { label: "Year", value: "{{right_now.year}}" },
  { label: "Date (month/day/year)", value: "{{right_now.middle_endian_date}}" },
  { label: "Date (day/month/year)", value: "{{right_now.little_endian_date}}" },
];

export const standardFonts = [
  { label: "Arial", value: "arial" },
  { label: "Helvetica", value: "helvetica" },
  { label: "Times", value: "times" },
  { label: "Palatino", value: "palatino" },
  { label: "Garamond", value: "garamond" },
];

export const popularFonts = [
  { label: "Roboto", value: "Roboto" },
  { label: "Open Sans", value: "Open Sans" },
  { label: "Noto Sans JP", value: "Noto Sans JP" },
  { label: "Montserrat", value: "Montserrat" },
  { label: "Lato", value: "Lato" },
  { label: "Poppins", value: "Poppins" },
  { label: "Roboto Condensed", value: "Roboto Condensed" },
  { label: "Inter", value: "Inter" },
  { label: "Roboto Mono", value: "Roboto Mono" },
  { label: "Oswald", value: "Oswald" },
  { label: "Raleway", value: "Raleway" },
  { label: "Noto Sans", value: "Noto Sans" },
  { label: "Nunito Sans", value: "Nunito Sans" },
  { label: "Roboto Slab", value: "Roboto Slab" },
  { label: "Ubuntu", value: "Ubuntu" },
  { label: "Nunito", value: "Nunito" },
  { label: "Playfair Display", value: "Playfair Display" },
  { label: "Merriweather", value: "Merriweather" },
  { label: "Rubik", value: "Rubik" },
  { label: "PT Sans", value: "PT Sans" },
  { label: "Kanit", value: "Kanit" },
];

export const FONT_FAMILY_OPTIONS: {
  label: string;
  value: string;
  style: { fontFamily: string };
}[] = [
  ...[...standardFonts, ...popularFonts].map((font) => ({
    label: font.label,
    value: font.value,
    style: { fontFamily: font.value },
  })),
  {
    label: "Andale Mono",
    value: "andale mono",
    style: {
      fontFamily: "andale mono",
    },
  },
  {
    label: "Arial Black",
    value: "arial black",
    style: {
      fontFamily: "arial black",
    },
  },
  {
    label: "Book Antiqua",
    value: "book antiqua",
    style: {
      fontFamily: "book antiqua",
    },
  },
  {
    label: "Comic Sans MS",
    value: "comic sans ms",
    style: {
      fontFamily: "comic sans ms",
    },
  },
  {
    label: "Courier New",
    value: "courier new",
    style: {
      fontFamily: "courier new",
    },
  },
  {
    label: "cursive",
    value: "cursive",
    style: {
      fontFamily: "cursive",
    },
  },
  {
    label: "Georgia",
    value: "georgia",
    style: {
      fontFamily: "georgia",
    },
  },
  {
    label: "Helvetica Neue",
    value: "helvetica neue",
    style: {
      fontFamily: "helvetica neue",
    },
  },
  {
    label: "Impact",
    value: "impact",
    style: {
      fontFamily: "impact",
    },
  },
  {
    label: "monospace",
    value: "monospace",
    style: {
      fontFamily: "monospace",
    },
  },
  {
    label: "Sans-serif",
    value: "sans-serif",
    style: {
      fontFamily: "sans-serif",
    },
  },
  {
    label: "serif",
    value: "serif",
    style: {
      fontFamily: "serif",
    },
  },
  {
    label: "Tahoma",
    value: "tahoma",
    style: {
      fontFamily: "tahoma",
    },
  },
  {
    label: "Terminal",
    value: "terminal",
    style: {
      fontFamily: "terminal",
    },
  },
  {
    label: "Times New Roman",
    value: "times new roman",
    style: {
      fontFamily: "times new roman",
    },
  },
  {
    label: "Trebuchet MS",
    value: "trebuchet ms",
    style: {
      fontFamily: "trebuchet ms",
    },
  },
  {
    label: "Verdana",
    value: "verdana",
    style: {
      fontFamily: "verdana",
    },
  },
];
